import { useEffect } from 'react';
import { useSocialShareModal } from '../SocialShareModalContext';
import { SocialSharePlatformData } from './types';

/**
 * Syncs the platform's accounts into the modal context when the platform has
 * finished authenticating and the modal's account list is still empty.
 */
export default function useSyncPlatformAccountsToModal(
  value: Pick<SocialSharePlatformData, 'authenticating' | 'accounts'>,
) {
  const { accounts, setAccounts } = useSocialShareModal();

  useEffect(() => {
    if (!value.authenticating && value.accounts?.length && !accounts.length) {
      setAccounts(value.accounts);
    }
  }, [accounts.length, setAccounts, value.accounts, value.authenticating]);
}
